import { sha1 } from './sha1.js';

const testUsersEmail = [
  '@mg.tp-qa-mail.com',
  '@tp-automatedtesting.com',
  '@martinbuberl.com',
  '@yopmail.com',
];

const getIdFromEmail = (email) => {
  email = email.toLowerCase();
  return sha1().hash(`${email}TrustpilotTackingHasherIsCool`);
};

function getEmailAddress() {
  const user = window.analytics.user && window.analytics.user();
  if (!user) {
    return;
  }

  const traits = user.traits();
  if (!traits) {
    return;
  }

  return traits.email;
}

function isTestUser(email) {
  email = email || getEmailAddress();

  if (!email) {
    return false;
  }

  const isTestEmail = testUsersEmail.some(function (testEmail) {
    return RegExp(`${testEmail}$`, 'i').test(email);
  });

  return isTestEmail;
}

function getOptions(options = {}, email) {
  if (isTestUser(email)) {
    return {
      integrations: {
        All: false,
      },
      ...options,
    };
  } else if (!window.getMarketingCookiesAllowed()) {
    return {
      integrations: window.getIntegrationsConfig(false),
      ...options,
    };
  }

  return options;
}

export default class Library {
  // eslint-disable-next-line class-methods-use-this
  get analytics() {
    return window.getPerformanceCookiesAllowed() ? window.analytics : undefined;
  }

  track(event, properties, options, callback) {
    if (typeof properties === 'function') {
      callback = properties;
      properties = {};
    } else if (typeof options === 'function') {
      callback = options;
      options = undefined;
    }

    this.analytics?.track(event, properties, getOptions(options), callback);
  }

  identify(email, traits, options, callback) {
    if (typeof traits === 'function') {
      callback = traits;
      traits = {};
    } else if (typeof options === 'function') {
      callback = options;
      options = undefined;
    }

    traits = traits || {};
    traits.email = traits.email || email;

    this.analytics?.identify(getIdFromEmail(email), traits, getOptions(options, email), callback);
  }

  page(category, name, properties, options, callback) {
    this.analytics?.page(category, name, properties, getOptions(options), callback);
  }
}
